import React, { useState } from 'react';
import { useOcrInputStore } from '../store/ocrInputStore';
import { DataInputInitialView } from './DataInputInitialView';
import { DataInputResultsView } from './DataInputResultsView';
import { PreviewModal } from './PreviewModal';

type StagedImage = { file: File; dataUrl: string } | null;

export const DataInputWorkflow: React.FC = () => {
  const { extractedData, selectedAsset, selectedTemplate } = useOcrInputStore();
  const [stagedImageForModal, setStagedImageForModal] = useState<StagedImage>(null);

  const handleFileStaged = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setStagedImageForModal({ file, dataUrl: reader.result as string });
      };
      reader.readAsDataURL(file);
    }
  };

  const closeModal = () => {
    setStagedImageForModal(null);
  };

  return (
    <>
      {extractedData ? (
        <DataInputResultsView onRetake={handleFileStaged} />
      ) : (
        <DataInputInitialView onFileSelect={handleFileStaged} />
      )}

      {stagedImageForModal && selectedAsset && selectedTemplate && (
        <PreviewModal
          isOpen
          image={stagedImageForModal}
          logbookTemplateId={selectedTemplate.logbookTemplateId}
          assetId={selectedAsset.assetId}
          templateId={selectedTemplate.id}
          onClose={closeModal}
        />
      )}
    </>
  );
};
